export default "__VITE_ASSET__Bls$cqpz__"